require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2006-04-its-full-of-code.json") })
        }
      }, "path---articles-2006-04-its-full-of-code");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2006-04-its-full-of-code!./.cache/json/articles-2006-04-its-full-of-code.json
// module id = 369
// module chunks = 231608221292675